import React, { useState, useEffect, useRef, useCallback } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import SimpleBar from "simplebar-react";

import withRouter from "../../../../components/messenger/withRouter";

//Import Components
import UserProfileSidebar from "../../../../components/messenger/UserProfileSidebar";
import SelectContact from "../../../../components/messenger/SelectContact";
import UserHead from "./UserHead";
import ChatInput from "./ChatInput";
//Import Images
import avatar4 from "../../../../assets/images/users/avatar-4.jpg";
import InfiniteScroll from "react-infinite-scroll-component";
//i18n
import { useTranslation } from "react-i18next";
import { useSocket } from "../../../../store/context/SocketProvider";
import { delMessage, updateMessages, updateGroupMessages } from "../../../../services/conversations";
import { uploadAttachment } from "../../../../services/attachments";
import ChatAvatar from "./ChatAvatar";
import ChatCallInfo from "./ChatCallInfo";
import ChatContent from "./ChatContent";
import ConversationName from "./ConversationName";
import ForwardMsgModal from "./ForwardMsgModal";
import PhotosTab from "./PhotosTab";
import FilesTab from "./FilesTab";

function UserChat(props) {
  const bottomRef = useRef();
  //console.log("socket provider", useSocket());
  const { socket } = useSocket();
  const [modal, setModal] = useState(false);
  const [conversationId, setConversationId] = useState("");
  const { t } = useTranslation();
  const [chatMessages, setchatMessages] = useState([]);
  const [page, setPage] = useState(1);
  const [isDrag, setDrag] = useState(false);
  const [isRecording, setIsRecording] = useState(false);

  const mediaRecorder = useRef(null);
  const [recordingStatus, setRecordingStatus] = useState("inactive");
  const [stream, setStream] = useState(null);
  const [audioChunks, setAudioChunks] = useState([]);
  const [audio, setAudio] = useState(null);
  const [farMsg, setFarMsg] = useState(null);
  const [activeUser, setActiveUser] = useState(props.contacts[props.active_user]);
  const [activeTab, setActiveTab] = useState("chat");
  const [images, setImages] = useState([]);
  const [media, setMedia] = useState([]);
  const [isEditing, setIsEditing] = useState({
    isEditing: false,
    messageId: null,
    messageText: "",
    currentChat: null,
  });

  // write a function to handler add and remove activeUser members
  const handleRemoveMember = (userId) => {
    if (activeUser.members) {
      setActiveUser((prev) => ({
        ...prev,
        members: prev?.members?.filter((member) => member._id !== userId),
      }));
    }
  };

  const addMemberHandler = (user) => {
    if (activeUser.members) {
      setActiveUser((prev) => ({
        ...prev,
        members: [...prev?.members, user],
      }));
    }
  };

  const updateActiveUserName = (updatedName) => {
    setActiveUser((prev) => ({
      ...prev,
      name: updatedName,
    }));
  }

  const handleForwardCLick = (msg) => {
    console.log("farMsg is", msg)
    setFarMsg(msg);
    toggle();
  };

  const getReceivers = (contact) => {
    let r = [];
    for (let usr of contact?.members) {
      if (usr._id != props.currentUser._id) {
        r.push(usr);
      }
    }
    return r;
  };

  const handleSentMessage = (msg) => {
    //console.log("message sent 200",msg);
    if (msg.isForwarded) {
      props.handleForwardMessage(msg)
    }
  }

  useEffect(() => {
    socket?.on("sentMessage", handleSentMessage);
    socket?.on("sentGroupMessage", handleSentMessage);

    return () => {
      socket?.off("sentMessage");
      socket?.off("sentGroupMessage");
    }
  }, [socket])

  const forwardMessage = (contact) => {
    console.log("contact...", contact);
    if (!socket?.connected) {
      window.alert("Socket is not connected please refresh.!");
      return;
    }
    //console.log(farMsg, contact);
    const messageObj = {
      ...farMsg,
      sender: props.currentUser?._id,
      receiver: contact?.isGroupChat ? getReceivers(contact) : contact.user?._id,
      conversationId: contact?.isGroupChat ? contact?._id : props.conversationsIds[contact?.index],
      forwardedBy: farMsg?.sender,
      isForwarded: true
    };
    delete messageObj._id;

    if (contact?.isGroupChat) {
      //console.log("forward group message sent",messageObj);
      socket.emit("sendMessageGroup", messageObj);
    } else {
      console.log("forward  message sent", messageObj);
      socket.emit("sendMessage", messageObj);
    }
    // const d = new Date();
    // props.handleForwardMessage({ ...messageObj, updatedAt: d.toLocaleString() });
    setModal(false);
  };

  const startRecording = () => {
    setIsRecording(true);
    let constraints = {
      audio: true,
      video: false,
    };

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(function (stream) {
        //console.log("initializing Recorder.js ...");

        setStream(stream);

        setRecordingStatus("recording");
        //create new Media recorder instance using the stream
        const media = new MediaRecorder(stream, { type: "audio/webm" });
        //set the MediaRecorder instance to the mediaRecorder ref
        mediaRecorder.current = media;
        //invokes the start method to start the recording process
        mediaRecorder.current.start();
        let localAudioChunks = [];
        mediaRecorder.current.ondataavailable = (event) => {
          if (typeof event.data === "undefined") return;
          if (event.data.size === 0) return;
          localAudioChunks.push(event.data);
        };
        setAudioChunks(localAudioChunks);
      })
      .catch(function (err) {
        //enable the record button if getUserMedia() fails
      });
  };

  const onStop = async (blob) => {
    console.log("uploading...", blob);
    //creates a blob file from the audiochunks data
    const audioBlob = new Blob(audioChunks, { type: "audio/webm" });
    //creates a playable URL from the blob file.
    const audioUrl = URL.createObjectURL(audioBlob);
    setAudio(audioUrl);
    setAudioChunks([]);
    // let data = new FormData();
    console.log("audio is", audioUrl, audioBlob);
    const d = new Date();
    const messageObj = {
      sender: props.currentUser?._id,
      receiver: props.contacts[props.active_user]?.isGroupChat
        ? filterReceivers()
        : props.contacts[props.active_user]?.user._id,
      message: "",
      media: [
        {
          fileName: "memo.wav",
          fileType: "audio/webm",
          filePath: audioUrl,
        },
      ],
      conversationId: conversationId,
      createdAt: d.toDateString(),
      callInfo: {
        isCall: false,
      },
    };

    let data = new FormData();
    data.append("attachments", audioBlob);

    const res = await uploadAttachment(data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Content-Length": blob.size,
      },
    });
    if (res.status == 200) {
      console.log("res is", res);
      if (props.contacts[props.active_user]?.isGroupChat) {
        console.log("group message sent");
        socket.emit("sendMessageGroup", { ...messageObj, media: res.data });
      } else {
        socket.emit("sendMessage", { ...messageObj, media: res.data });
      }
      props.setMessagestoState({
        ...messageObj,
        media: res.data,
        updatedAt: d.toLocaleString(),
      });
    }
  };
  const stopRecording = useCallback(() => {
    setIsRecording(false);
    setRecordingStatus("inactive");
    //stops the recording instance
    mediaRecorder.current.stop();
    mediaRecorder.current.onstop = onStop;
  }, [mediaRecorder, onStop]);

  const filterReceivers = () => {
    const arr = props.contacts[props.active_user]?.members;
    let data = [];
    for (const key in arr) {
      const user = arr[key];
      if (user._id != props?.currentUser?._id) {
        //console.log("filter user", user);
        data.push(user._id);
      }
    }
    return data;
  };

  const toggle = () => setModal(!modal);

  console.log("isEditing", isEditing);

  const updateMessage = async (updatedMessage) => {
    console.log("updating...........................updating...")
    const isGroupChat = props.contacts[props.active_user]?.isGroupChat;
    //console.log("del", chat);
    try {
      let updatedMsg;

      if (!isGroupChat) {
        updatedMsg = await updateMessages(isEditing.messageId, { ...isEditing.currentChat, message: updatedMessage });
      } else {
        updatedMsg = await updateGroupMessages(isEditing.messageId, { ...isEditing.currentChat, message: updatedMessage });
      }

      if (updatedMsg.status == 200) {
        //console.log(res);
        // props.deleteMessageFromState(isEditing.messageId);
        toast.success(`Message has been updated!`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        props.updateSingleMessageInState({ id: isEditing.messageId, updatedMessage });
      }
    } catch (e) {
      console.log(e);
    }
  };

  const addMessage = (message, type) => {
    //console.log(message, type);
    var messageObj = null;

    let d = new Date();
    var n = d.getSeconds();

    //matches the message type is text, file or image, and create object according to it
    switch (type) {
      case "textMessage":
        messageObj = {
          sender: props.currentUser?._id,
          receiver: props.contacts[props.active_user]?.isGroupChat
            ? filterReceivers()
            : props.contacts[props.active_user]?.user._id,
          message: message,
          media: [],
          conversationId: conversationId,
          createdAt: d.toDateString(),
          status: 'delivered',
          callInfo: {
            isCall: false,
          },
        };
        break;

      case "fileMessage":
        messageObj = {
          id: chatMessages.length + 1,
          message: "file",
          fileMessage: message.name,
          size: message.size,
          time: "00:" + n,
          userType: "sender",
          image: avatar4,
          isFileMessage: true,
          isImageMessage: false,
          status: 'delivered',
          callInfo: {
            isCall: false,
          },
        };
        break;

      case "imageMessage":
        messageObj = {
          sender: props.currentUser?._id,
          receiver: props.contacts[props.active_user]?.isGroupChat
            ? filterReceivers()
            : props.contacts[props.active_user]?.user._id,
          message: "",
          media: message,
          conversationId: conversationId,
          createdAt: d.toDateString(),
          status: 'delivered',
          callInfo: {
            isCall: false,
          },
        };
        break;

      default:
        break;
    }

    //console.log("sending message", socket, messageObj);
    socket.on("sentGroupMessage", () => {
      console.log("message sent", messageObj);
    });

    if (props.contacts[props.active_user]?.isGroupChat) {
      //console.log("group message sent");
      socket.emit("sendMessageGroup", messageObj);
    } else {
      socket.emit("sendMessage", messageObj);
    }

    props.setMessagestoState({ ...messageObj, updatedAt: d.toLocaleString() });
  };

  const deleteMessage = async (chat) => {
    const isGroupChat = props.contacts[props.active_user]?.isGroupChat;
    //console.log("del", chat);
    try {
      let updatedMsg;

      if (!isGroupChat) {
        updatedMsg = await updateMessages(chat._id, { ...chat, status: "deleted" });
      } else {
        updatedMsg = await updateGroupMessages(chat._id, { ...chat, status: "deleted" });
      }

      if (updatedMsg.status == 200) {
        //console.log(res);
        props.deleteMessageFromState(chat._id);
        toast.success(`Message deleted.!`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  const formatDate = (date) => {
    const renderNumber = (value, size) => {
      const text = String(value);
      return text.padStart(size, "0");
    };
    let PM = false;
    let newHours;
    const year = renderNumber(date.getFullYear(), 4);
    const month = renderNumber(date.getMonth() + 1, 2);
    const day = renderNumber(date.getDate(), 2);
    const hours = renderNumber(date.getHours(), 2);
    const minutes = renderNumber(date.getMinutes(), 2);
    const seconds = renderNumber(date.getSeconds(), 2);
    if (hours >= 12) {
      newHours = hours - 12;
      PM = true;
    }
    if (PM) {
      return `${newHours}:${minutes} PM  ${day}/${month}/${year}  `;
    } else {
      return `${hours}:${minutes} AM  ${day}/${month}/${year}  `;
    }
  };

  const getUserofGroupChat = (arr, id) => {
    let u;
    for (const user of arr) {
      if (user._id == id) {
        u = user;
      }
    }
    return u ? u : false;
  };

  const fetchNextData = () => {
    //console.log("fetching");
    props.handleFetchMore(
      conversationId,
      props.contacts[props.conversationsIds.indexOf(conversationId)]
        ?.isGroupChat,
      page++
    );
    setPage(page++);
  };

  useEffect(() => {
    if (!socket) return;

    const handleMessageSeen = (data) => {
      console.log("Socket data (messageSeen):", data);
      setchatMessages((prevMsg) => {
        if (!prevMsg || prevMsg.length === 0) return prevMsg;

        const updatedMsg = [...prevMsg];
        const lastMsg = { ...updatedMsg[updatedMsg.length - 1], status: 'seen' };
        updatedMsg[updatedMsg.length - 1] = lastMsg;

        return updatedMsg;
      });
    };

    socket.on("messageSeen", handleMessageSeen);

    return () => {
      socket.off("messageSeen", handleMessageSeen);
    };
  }, [socket]);

  useEffect(() => {
    const activeUser = props?.active_user;
    const conversations = props?.conversations?.[activeUser];
    const contact = props?.contacts?.[activeUser];
    const currentUser = props?.currentUser;

    if (!conversations) return;

    const currentConversation = conversations[0];

    const allMedia = currentConversation.flatMap((msg) => {
      if (msg.status === 'deleted') return [];
      if (!msg.media?.length) return [];

      const isCurrentUser = msg.sender === currentUser._id;

      // Determine sender name
      let name = '';
      if (contact?.isGroupChat) {
        const sender = isCurrentUser
          ? currentUser
          : getUserofGroupChat(contact.members, msg.sender);
        name = `${sender?.contactName?.first || ''} ${sender?.contactName?.last || ''}`;
      } else {
        name = isCurrentUser
          ? `${currentUser.contactName.first} ${currentUser.contactName.last}`
          : contact?.name || '';
      }

      return msg.media.map((m) => ({
        ...m,
        createdAt: msg.createdAt,
        conversation: msg,
        sentBy: name,
      }));
    });

    const allImages = allMedia.filter((m) => m.fileType?.startsWith('image/'));

    setMedia(allMedia);
    setImages(allImages);
    setchatMessages(currentConversation);
    setConversationId(props?.conversationsIds?.[activeUser]);

  }, [props.active_user, props.conversations, props.conversationsIds]);

  useEffect(() => {
    if (props?.contacts[props?.active_user]) {
      setActiveUser(props?.contacts[props?.active_user]);
    }
  }, [props.active_user, props.contacts]);

  useEffect(() => {
    bottomRef.current.recalculate();
    //console.log(bottomRef.current);
    if (bottomRef.current.el) {
      bottomRef.current.getScrollElement().scrollTop =
        bottomRef.current.getScrollElement().scrollHeight;
    }
    // <- the root element you applied SimpleBar on
  });

  return (
    <React.Fragment>
      <div
        className={`user-chat w-100 mt-2 ${props.isForVideoChat && props.isShow ? "user-chat-show" : ""}`}
        onDragOver={(e) => {
          e.preventDefault();
          setDrag(true);
        }}
        onDragLeave={() => setDrag(false)}
      >
        <div className="d-lg-flex position-relative h-100">
          <div className={props.userSidebar ? "w-70" : "w-100"}>
            {/* render user head */}
            {!props.isForVideoChat && (
              <UserHead
                handleDelConversation={props.handleDelConversation}
                updateMessages={props.setMessagestoState}
                conversationId={conversationId}
                addMemberHandler={addMemberHandler}
                contacts={activeUser}
                currentUser={props.currentUser}
                allContacts={props.contacts}
                updateContacts={props.updateContacts}
                updateConversations={props.handleUpdateConversations}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                fetchUpdatedMessages={props.fetchUpdatedMessages}
              />
            )}

            <SimpleBar
              style={{ maxHeight: "100%" }}
              ref={bottomRef}
              className={
                props.isForVideoChat
                  ? "videochat-conversation"
                  : "chat-conversation p-3 p-lg-4"
              }
              id="messages"
            >
              <ul
                className="list-unstyled mb-0"
                id="scrollableDiv"
                style={{ height: "100%", overflow: "auto" }}
              >
                <InfiniteScroll
                  dataLength={chatMessages.length}
                  loader={<h4>Loading...</h4>}
                  // style={{ display: 'flex', flexDirection: 'column-reverse' }}
                  next={fetchNextData}
                  inverse={true}
                  hasMore={true}
                  scrollableTarget="scrollableDiv"
                >
                  {activeTab === 'photos' && (<PhotosTab photos={images} />)}

                  {activeTab === 'files' && (<FilesTab files={media} setMedia={setMedia} isGroupChat={props.contacts[props.active_user]?.isGroupChat} deleteMessageFromState={props.deleteMessageFromState} />)}

                  {activeTab === 'chat' && chatMessages?.map((chat, key) => {
                    // if (chat.status === 'deleted' || (!chat?.message && chat?.media?.length === 0)) return null;
                    if (!chat?.message && chat?.media?.length === 0) return null;

                    const isCurrentUser = chat.sender === props.currentUser?._id;
                    const isGroupChat = props.contacts[props.active_user]?.isGroupChat;
                    const isCall = chat.callInfo?.isCall;
                    const isForwarded = chatMessages[key]?.forwardedBy && chatMessages[key]?.forwardedBy._id !== props.currentUser?._id;
                    const forwardedName = chatMessages[key]?.forwardedBy?.contactName?.first;

                    if (chat.isToday) {
                      return (
                        <li key={"dayTitle" + key}>
                          <div className="chat-day-title">
                            <span className="title">Today</span>
                          </div>
                        </li>
                      );
                    }

                    const renderForwardedInfo = () =>
                      isForwarded && (
                        <div className="flex gap-2 ml-2">
                          <i className="ri-share-forward-fill"></i>
                          <span className="text-xs">{forwardedName}</span>
                        </div>
                      );

                    const renderAvatar = () =>
                      <ChatAvatar
                        chat={chat}
                        currentUser={props.currentUser}
                        contacts={props.contacts}
                        active_user={props.active_user}
                        isGroup={isGroupChat}
                        getUserofGroupChat={getUserofGroupChat}
                      />

                    const renderConversationName = () =>
                      !isCurrentUser && (
                        <ConversationName
                          chat={chat}
                          currentUser={props.currentUser}
                          contacts={props.contacts}
                          activeUser={props?.active_user}
                          getUserofGroupChat={getUserofGroupChat}
                          isGroupChat={isGroupChat}
                        />
                      );

                    const renderContent = () => {
                      const isDeleted = chat.status === 'deleted' || chat.isDeleted;

                      if (isDeleted) {
                        return (
                          <div className="flex items-center text-gray-500 italic px-3 py-2 text-sm bg-gray-200 rounded-md">
                            <i className="ri-information-line mr-1"></i> This message was deleted
                          </div>

                        );
                      }

                      return isCall ? (
                        <ChatCallInfo
                          chat={chat}
                          currentUser={props.currentUser}
                          callInfo={chat.callInfo}
                          formatDate={formatDate}
                          deleteMessage={deleteMessage}
                          forwarded={isForwarded}
                          isGroup={isGroupChat}
                        />
                      ) : (
                        <ChatContent
                          chat={chat}
                          chatMessages={chatMessages}
                          key={key}
                          activeTab={activeTab}
                          currentUser={props.currentUser}
                          formatDate={formatDate}
                          handleForwardCLick={handleForwardCLick}
                          deleteMessage={deleteMessage}
                          isGroup={isGroupChat}
                          editHandler={setIsEditing}
                        />
                      );
                    };


                    return (
                      <li key={key} className={isCurrentUser ? "right" : ""}>
                        <div className="conversation-list">
                          {renderAvatar()}
                          <div className="user-chat-content">
                            {renderConversationName()}
                            {renderForwardedInfo()}
                            {renderContent()}
                            {isCurrentUser && chatMessages.length - 1 === key && (
                              <div className="flex items-center gap-1 mt-1">
                                {chat.status === "delivered" && (
                                  <i className="ri-check-line text-gray-500 text-xs" title="Delivered"></i>
                                )}
                                {chat.status === "seen" && (
                                  <i className="ri-check-double-line text-blue-500 text-xs" title="Seen"></i>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </li>
                    );
                  })}

                </InfiniteScroll>
              </ul>
            </SimpleBar>

            <ForwardMsgModal
              contacts={props.contacts}
              modal={modal}
              toggle={toggle}
              forwardMessage={forwardMessage}
            />

            {activeTab === 'chat' && (
              <ChatInput
                onaddMessage={addMessage}
                updateMessages={updateMessage}
                className={props.isForVideoChat ? "video-chat-input" : ""}
                isForVideoChat={props.isForVideoChat}
                isDrag={isDrag}
                setDrag={setDrag}
                isRecording={isRecording}
                startRecording={startRecording}
                stopRecording={stopRecording}
                conversationId={conversationId}
                currentUser={props.currentUser}
                isGroupchat={props.contacts[props.active_user]?.isGroupChat}
                msgSeenUpdate={props.msgSeenUpdate}
                defaultValue={isEditing.isEditing ? isEditing.messageText : ""}
                isEditing={isEditing.isEditing}
              />
            )}
          </div>

          {!props.isForVideoChat && (
            <UserProfileSidebar
              activeUser={activeUser}
              handleRemoveMember={handleRemoveMember}
              updateActiveUserName={updateActiveUserName}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  const { userSidebar } = state.Layout;
  return { userSidebar };
};

export default withRouter(connect(mapStateToProps, {})(UserChat));
